module.exports = __webpack_public_path__ + "img/54.3ba97b0e.webp";